export default __webpack_public_path__ + "static/media/star_half.2ae222a1.svg";